var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3978361,74.8088093 L23.3978361,21.1908446 C23.3978361,18.3358801 25.5270293,16 28.1293766,16 L35.7329622,16 C38.3353095,16 40.4645027,18.3358801 40.4645027,21.1908446 L40.4645027,74.8088093 C40.4645027,77.6637739 38.3353095,79.9996539 35.7329622,79.9996539 L28.1293766,79.9996539 C25.5270293,79.9996539 23.3978361,77.6637739 23.3978361,74.8088093 Z M60.2666006,16.0003461 L67.8710606,16.0003461 C70.4731674,16.0003461 72.6021639,18.3362261 72.6021639,21.1911907 L72.6021639,74.8091554 C72.6021639,77.6641199 70.4731674,80 67.8710606,80 L60.2666006,80 C57.6660708,80 55.5354973,77.6641199 55.5354973,74.8091554 L55.5354973,21.1911907 C55.5354973,18.3362261 57.6660708,16.0003461 60.2666006,16.0003461 Z",
    fill: "#000000",
    fillRule: "evenodd"
  })));
};
export default SvgPause;